import styled from '@emotion/styled';
import { theme } from '../../constants/theme';

export const StyledCheckbox = styled.div`
  display: inline-flex;
  flex-direction: column;

  .MuiFormControlLabel-root {
    margin-left: 0;
    margin-right: 0;
    user-select: none;

    .MuiFormControlLabel-label {
      color: ${props => props.$error ? theme.colors.error.main : theme.colors.text.primary};
      font-size: ${props => props.$size === 'sm' ? theme.typography.fontSize.xs : theme.typography.fontSize.sm};
      font-weight: ${theme.typography.fontWeight.regular};
      
      &.Mui-disabled {
        color: ${theme.colors.text.disabled};
      }
    }
  }

  .helper-text {
    margin-left: ${theme.spacing.lg};
    margin-top: ${theme.spacing.xs};
    font-size: ${theme.typography.fontSize.xs};
    color: ${props => props.$error ? theme.colors.error.main : theme.colors.text.secondary};
  }

  .MuiCheckbox-root {
    transition: ${theme.transitions.duration.fast} ${theme.transitions.timing.easeInOut};
    
    &:hover {
      background-color: ${theme.colors.primary.light}15;
    }
  }
`;
